// extracted by mini-css-extract-plugin
export default {"content-root":"_3FJuU","contentRoot":"_3FJuU","title":"_2eLD1","message":"_1bn6g","image":"_2v2lG"};